import { Trade } from "@models/trade";
import { CryptoTransaction } from "@models/transaction/crypto_transaction";

export class LeveragedTokenTransaction extends CryptoTransaction {
	private starting_borrow: string = "";
	private closing_borrow: string = "";
	protected trade: Trade = new Trade();

	public hasAction(cancel: boolean = false): boolean {
		// Todo
		return false;
	}

	public isCancelable(): boolean {
		// Todo
		return false;
	}

	public get displayRecipient(): string {
		// Todo
		return "";
	}

	public getStartingBorrow(): string {
		return this.starting_borrow;
	}

	public getClosingBorrow(): string {
		return this.closing_borrow;
	}

	public getTradeStartingBorrow(): string {
		return this.trade.starting_borrow;
	}

	public getTradeClosingBorrow(): string {
		return this.trade.closing_borrow;
	}
}
